import React from "react";
import MainRoute from "./MainRoute";
const AppRouter: React.FC = () => {
  return <MainRoute />;
};
export default AppRouter;
